<template>
  <div class="HeaderFooter" v-model="readcms">
    <template v-if="view_area === 'header'">
      <div v-html="headerFooter.field_header" />
    </template>
    <template v-else-if="view_area === 'footer'">
      <div v-html="headerFooter.field_footer" />
    </template>
  </div>
</template>

<script>
export default {
  name: "HeaderFooter",
  props: {
    view_area: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      error: null,
      headerFooter: {},
    };
  },
  watch: {},
  computed: {
    async readcms() {
      const APIres = await this.$repositories("cms").getHeaderFooter({
        bsCode: process.env.VUE_APP_CMS_BS_CODE
      });
      return this.setResponse(APIres);
    },
  },
  methods: {
    setResponse(obj) {
      if (
          !obj ||
          !obj.data ||
          !obj.data.data ||
          !obj.data.data[0]
      ) {
        return;
      }
      this.headerFooter = {
        field_footer : obj.data.data[0].attributes.field_footer.value,
        field_header : obj.data.data[0].attributes.field_header.value
      }
    },
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  destroyed() {
  },
}
</script>

<style scoped>
@screen lg {
  ::v-deep .footer-menu-list {
    width: 100%;
  }
}

</style>